import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'

export type IQuotationSaleDTO = {
  reference: string | null
}

export class QuotationSaleDTO {
  reference: string | null

  constructor(data: IQuotationSaleDTO) {
    this.reference = data.reference
  }
}

const validate = createValidate<IQuotationSaleDTO | null>()

export const parseQuotationSaleDTO = (data: unknown): QuotationSaleDTO | null => {
  validateGuard(validate, data, 'quotation sale')
  if (data === null) return null
  return new QuotationSaleDTO(data)
}
